export const theme = {
  token: {
    colorPrimary: '#207AFF'
  },
  components: {
    Radio: {
      colorText: '#262626'
    },
    Dropdown: {
      controlItemBgHover: '#EDF7FF'
    },
    Select: {
      optionSelectedColor: 'rgb(32, 122, 255)',
      optionSelectedFontWeight: 400
    }
  }
};
